export const applicationsCreatorFormUrl = '/applications/creator_form'
export const applicationsPendingUrl = '/dashboard'
export const applicationIntroUrl = '/applications/intro'
